import _ from 'lodash';
import { SportsbookCommunicator, SportsbookEventsEnum } from '@lbs/sportsbook';

import { changeSecondScreen } from '@common/helpers/secondScreen';
import Helpers from '@common/helpers/helperFunctions';
import { POPUPS } from '@common/constants/popups';
import Config from '@skin_config';

import { sportsWithAnimations } from '../helpers/sportsWithAnimations';
import { getPopupDispatchers } from '../contexts/popup';
import { getTerminalLanguage } from '../helpers/languageByIdOrConfig';

const openStatistics = ({ game }) => {
  const {
    URL,
    pwd,
  } = Config.statisticParams;
  const terminalLang = getTerminalLanguage();

  const secondScreenChanged = changeSecondScreen(Config, {
    command: 'Statistics',
    id: game.id,
    url: '',
    providerId: 0,
  });

  if (!secondScreenChanged && URL) {
    const lang = Config.main.availableLanguages[terminalLang].short.toLowerCase();
    const data = {
      langId: lang,
      matchId: game.id,
      pwd,
    };

    const url = _.template(URL)(data);

    const { openPopup } = getPopupDispatchers();
    openPopup(POPUPS.STATISTICS_POPUP, { url });
  }
};

const openBetBuilder = ({ game }) => {
  const popupData = {
    title: `${game.team1_name} vs ${game.team2_name}`,
    sportcastId: game.sportcast_id,
  };

  const { openPopup } = getPopupDispatchers();
  openPopup(POPUPS.BET_BUILDER, popupData);
};

const toggleGameDetails = ({
  game,
  gameType,
}) => {
  if (!game) {
    changeSecondScreen(Config, {
      command: 'Default',
      id: 0,
      url: '',
      providerId: 0
    });
    return;
  }

  // if (Config.upper_screen.live_streaming && (gameType === 'live' || isVirtualGame) && this?.videoData) {
  //   changeSecondScreen(Config, { command: 'Video', id: data.id, url: this?.videoData, providerId: data.tv_type });
  // }

  if (!Helpers.isSecondScreenAvailable(Config)) {
    // const params = {
    //   url: this.videoData,
    //   providerId: data.tv_type,
    //   gmaeId: data.id,
    // };
    // data.video_id && dispatch(virtualsVideoStream(params));
  } else if (
    !Config.terminal.disabledAutoOpenGameStatistics &&
    game.is_stat_available &&
    ((Config.upper_screen.statistics_live && gameType === 'live') ||
      (Config.upper_screen.statistics_prematch && gameType !== 'live'))
  ) {
    changeSecondScreen(Config, {
      command: 'Statistics',
      id: game.id,
      url: '',
      providerId: 0
    });
  } else if (!Config.sportsbook.enableBannerAnimation && Config.upper_screen.live_animations && gameType === 'live') {
    if (sportsWithAnimations.has(game.sport.alias)) {
      changeSecondScreen(Config, {
        command: 'Animation',
        id: game.id,
        url: '',
        providerId: 0
      });
    }
  } else if (Config.sportsbook.enableBannerAnimation && Config.upper_screen.live_animations && gameType === 'live') {
    if (sportsWithAnimations.has(game.sport.alias)) {
      changeSecondScreen(Config, {
        command: 'LiveAnimation',
        id: game.id,
        url: '',
        providerId: 0,
      });
    }
  }
};

const openVideoStream = ({
  url,
  stream
}) => {
  const secondScreenChanged = changeSecondScreen(Config, {
    command: 'Video',
    url,
    id: stream.video_id,
    providerId: stream.provider_id,
  });

  if (!secondScreenChanged) {
    const params = {
      url,
      providerId: stream.provider_id,
      gameId: stream.video_id,
    };

    const { openPopup } = getPopupDispatchers();
    openPopup(POPUPS.VIDEO_STREAM, params);
  }
};

const emitToggleVirtualGame = _.debounce((data) => {
  if (!data.id) {
    changeSecondScreen(Config, {
      command: 'Default',
      id: 0,
      url: '',
      providerId: 0,
    });
    return;
  }
  const secondScreenChanged = changeSecondScreen(Config, {
    command: 'Video',
    id: data.id,
    url: data.url.data?.data || data.url,
  });
}, 200);

const openClickVirtualStream = (data) => {
  if (_.isEmpty(data) || data.length) return null;
  const params = {
    url: data.url.data?.data,
    providerId: data.provider_id,
    gameId: data.id,
  };

  const { openPopup } = getPopupDispatchers();
  openPopup(POPUPS.VIDEO_STREAM, params);
};

export const initSportsbookListeners = _.once(() => {
  SportsbookCommunicator.on(SportsbookEventsEnum.OpenStatistics, openStatistics);
  SportsbookCommunicator.on(SportsbookEventsEnum.OpenBetBuilder, openBetBuilder);
  SportsbookCommunicator.on(SportsbookEventsEnum.ToggleGameDetails, toggleGameDetails);
  SportsbookCommunicator.on(SportsbookEventsEnum.OpenVideoStream, openVideoStream);
  SportsbookCommunicator.on(SportsbookEventsEnum.ToggleVirtualGame, emitToggleVirtualGame);
  SportsbookCommunicator.on(SportsbookEventsEnum.OnClickVirtualStream, openClickVirtualStream);
});
